module.exports = __webpack_public_path__ + "static/img/1.4581cdd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/4/zh/1.png
// module id = SXUS
// module chunks = 0